import { SVGProps, Ref, forwardRef } from 'react';

export const PlayCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m12 1 .383.004c7.7.162 10.443 5.243 10.61 10.48L23 12c0 5.5-2.75 11-11 11S1 17.5 1 12l.008-.516C1.177 6.162 4.008 1 12 1m-.446 6.951c-1.607-.813-2.411-1.22-2.983-.757C8 7.657 8 8.714 8 10.828v2.344c0 2.113 0 3.171.571 3.634.572.462 1.376.056 2.983-.757v-.001l2.312-1.17.002-.001C16.29 13.652 17.5 13.039 17.5 12c0-1.04-1.211-1.653-3.634-2.879l-2.311-1.169z"
            fill="currentColor"
        />
    </svg>
));
PlayCircleFilledSize24Glyph.displayName = 'PlayCircleFilledSize24Glyph';
